import { GQL } from "@binale-tech/shared";

import { buildAssistantQueue } from "@dms/components/DmsSortAssistant/buildAssistantQueue";

import { DmsType } from "@domain/models/dms";

import type { AgentDetailItem, AgentStep, ReportLine } from "../runner/types";

export const sortQuestionsStep: AgentStep = {
    id: "sortQuestions",
    product: [GQL.IProductKey.Dms],
    needs: ["autoSort"],
    async run(ctx, io) {
        const steps = buildAssistantQueue(ctx.autoSortResults);
        if (steps.length === 0) return { status: "nothing" };

        io.post({ kind: "question", textId: "app.agent.sortQuestions.intro", values: { count: steps.length } });
        const reported: { answered: number; later: number }[] = [];
        await io.panel({
            type: "sortAssistant",
            steps,
            onResult: (answered, later) => {
                reported.push({ answered, later });
            },
        });
        // Closed without a report: nothing was answered, every question stays open.
        const { answered, later } = reported.at(-1) ?? { answered: 0, later: steps.length };

        // a queue document that is no longer in Neue Dokumente was sorted, the others stay open
        const docs = ctx.documents();
        const details = [...new Set(steps.map((step) => step.documentId))].map((id): AgentDetailItem => {
            const ref = { kind: "document" as const, id };
            return docs.get(id)?.type === DmsType.new_documents
                ? { group: "needsYou", ref, outcome: { textId: "app.agent.details.sortQuestions.stillOpen" } }
                : { group: "done", ref, outcome: { textId: "app.agent.details.sortQuestions.left" } };
        });

        io.post({ kind: "done", textId: "app.agent.sortQuestions.done", values: { answered, later }, details });
        const summary: ReportLine[] =
            answered > 0 ? [{ textId: "app.agent.report.sortAnswered", values: { count: answered } }] : [];
        const open: ReportLine[] =
            later > 0 ? [{ textId: "app.agent.report.sortLater", values: { count: later } }] : [];
        return { status: answered > 0 ? "done" : "nothing", summary, open, details };
    },
};
